module.exports = __webpack_public_path__ + "static/media/cod-mw.f0f407e5.jpg";